export default __webpack_public_path__ + "files/marker_monitoring_site_down-51130a7a3167ae8a93c92744bdd8f1f8.png";